import { Trash2, Plus } from 'lucide-react';
import { Button } from '../common/Button';
import type { CustomRedFlag } from '../../types';

interface CustomRedFlagEditorProps {
  flags: CustomRedFlag[];
  onAdd: () => void;
  onUpdate: (flagId: string, updates: Partial<CustomRedFlag>) => void;
  onDelete: (flagId: string) => void;
}

export function CustomRedFlagEditor({ flags, onAdd, onUpdate, onDelete }: CustomRedFlagEditorProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h4 className="text-wolf-300 text-sm font-medium">Custom Red Flags</h4>
        <Button variant="secondary" size="sm" onClick={onAdd}>
          <Plus className="w-4 h-4 mr-1" />
          Add Custom Flag
        </Button>
      </div>

      {flags.length === 0 ? (
        <p className="text-wolf-500 text-sm italic">No custom red flags defined</p>
      ) : (
        <div className="space-y-3">
          {flags.map((flag) => (
            <div
              key={flag.id}
              className="bg-wolf-800 border border-wolf-600 rounded-lg p-3"
            >
              <div className="flex items-start gap-3">
                <div className="flex-1 space-y-2">
                  <input
                    type="text"
                    className="w-full bg-wolf-900 border border-wolf-600 rounded px-2 py-1 text-white text-sm"
                    value={flag.label}
                    onChange={(e) => onUpdate(flag.id, { label: e.target.value })}
                    placeholder="Flag label..."
                  />
                  <textarea
                    className="w-full bg-wolf-900 border border-wolf-600 rounded px-2 py-1 text-wolf-300 text-sm"
                    rows={2}
                    value={flag.description}
                    onChange={(e) => onUpdate(flag.id, { description: e.target.value })}
                    placeholder="Description of what triggers this flag..."
                  />
                </div>
                <button
                  type="button"
                  onClick={() => onDelete(flag.id)}
                  className="text-wolf-500 hover:text-red-400 transition-colors p-1"
                  title="Delete flag"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
